"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const QwilrPayCircle = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "37", height: "38", viewBox: "0 0 37 38", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M18.113 36.6273C27.6923 36.6273 35.4579 28.8618 35.4579 19.2824C35.4579 9.70309 27.6923 1.9375 18.113 1.9375C8.53365 1.9375 0.768066 9.70309 0.768066 19.2824C0.768066 28.8618 8.53365 36.6273 18.113 36.6273Z",
        fill: "#605CAB",
        stroke: "#D1D7E2",
        strokeWidth: 0.988387
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        opacity: 0.7,
        d: "M11.7645 23.5424L11.1 22.7184C10.6082 22.9709 10.0368 23.1038 9.43868 23.1038C7.16603 23.1038 5.58447 21.3229 5.58447 18.8908C5.58447 16.4454 7.16603 14.6777 9.43868 14.6777C11.7113 14.6777 13.3062 16.4454 13.3062 18.8908C13.3062 20.1002 12.8942 21.1369 12.2031 21.8944L12.8543 22.6918L11.7645 23.5424ZM11.5918 18.8908C11.5918 17.2959 10.7412 16.1928 9.43868 16.1928C8.14952 16.1928 7.31223 17.2959 7.31223 18.8908C7.31223 20.4856 8.14952 21.6286 9.43868 21.6286C9.69121 21.6286 9.93043 21.602 10.1431 21.5356L9.47856 20.6982L10.5684 19.8609L11.2063 20.6584C11.4589 20.2198 11.5918 19.6351 11.5918 18.8908Z",
        fill: "white"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M15.3846 22.4789V25.1636H13.7366V17.0299H15.3846V17.5216C15.6504 17.2026 16.2352 16.897 16.8731 16.897C18.6009 16.897 19.5844 18.3323 19.5844 20.0069C19.5844 21.6815 18.6009 23.1035 16.8731 23.1035C16.2352 23.1035 15.6504 22.7979 15.3846 22.4789ZM15.3846 19.0234V20.9771C15.5839 21.3891 16.0226 21.6682 16.501 21.6682C17.3915 21.6682 17.9231 20.9505 17.9231 20.0069C17.9231 19.05 17.3915 18.3323 16.501 18.3323C16.0092 18.3323 15.5839 18.6247 15.3846 19.0234ZM25.066 22.9706H23.4844V22.6516C23.285 22.8511 22.687 23.0769 22.0358 23.0769C20.8396 23.0769 19.8295 22.3858 19.8295 21.1498C19.8295 20.0202 20.8396 19.2493 22.1288 19.2493C22.6471 19.2493 23.2452 19.4221 23.4844 19.5949V19.1563C23.4844 18.6513 23.1787 18.2393 22.5142 18.2393C22.049 18.2393 21.77 18.4519 21.637 18.7974H20.0687C20.2416 17.7209 21.2117 16.897 22.5674 16.897C24.149 16.897 25.066 17.7608 25.066 19.1829V22.9706ZM23.4844 21.3492V20.9239C23.3382 20.605 22.8864 20.4056 22.4079 20.4056C21.8895 20.4056 21.3579 20.6315 21.3579 21.1366C21.3579 21.6549 21.8895 21.8675 22.4079 21.8675C22.8864 21.8675 23.3382 21.6682 23.4844 21.3492ZM28.2689 25.1636H26.6474L27.5113 22.9972L25.2386 17.0299H26.9797L28.3487 20.9771L29.7042 17.0299H31.3655L28.2689 25.1636Z",
        fill: "white"
      }
    )
  );
};
export default QwilrPayCircle;
